import type { ReactNode} from 'react';
import { useState } from 'react';

import type { RewardPool, RewardPoolTicketCurrencyType } from '@shared/api/types/rewardPools';
import { AuthWeb3Modal } from '@shared/common/components/modals/AuthWeb3Modal';
import { useAuth } from '@shared/common/providers/AuthProvider';
import { useRewardPoolSelfEntries } from '@shared/hooks/query/rewardPools';

import { isRewardPoolActive } from '@store:web/components/entities/rewardPool/model/rewardPoolStatus';
import { checkLimitByTicketsReached } from '@store:web/components/entities/rewardPool/model/ticketLimitCalculation';

import { ListItemButton } from '../../List/ListItemButton';
import { GetTicketsModal } from './GetTicketsModal';

type Props = {
  currencyType: RewardPoolTicketCurrencyType;
  rewardPool: RewardPool;
  dataQaAttribute: string;
  children: ReactNode;
};

export const GetTicketsButton = ({
  currencyType,
  rewardPool,
  dataQaAttribute,
  ...props
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenEVMModal, setIsOpenEVMModal] = useState(false);
  const { data: entries = [] } = useRewardPoolSelfEntries(rewardPool.id);
  const { isAuth } = useAuth();

  const closeModalHandler = () => {
    setIsModalOpen(false);
  };

  const openModalHandler = () => {
    if (!isAuth) {
      setIsOpenEVMModal(true);

      return;
    }

    setIsModalOpen(true);
  };

  const isLimitByTicketReached = checkLimitByTicketsReached(rewardPool, entries.length);

  const isDisabled = !isRewardPoolActive(rewardPool) || isLimitByTicketReached;

  return (
    <>
      <GetTicketsModal
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
        currencyType={currencyType}
        rewardPool={rewardPool}
        closeModal={closeModalHandler}
      />
      <AuthWeb3Modal isOpen={isOpenEVMModal} setIsOpen={setIsOpenEVMModal} />
      <ListItemButton
        {...props}
        data-qa={dataQaAttribute}
        onClick={openModalHandler}
        disabled={isDisabled}
      />
    </>
  );
};
